import { Link } from 'react-router-dom';

/**
 * variant:
 * - auto (default): follows system light/dark like Android
 * - light: logo for light backgrounds
 * - dark: logo for dark/colored backgrounds (e.g. auth hero)
 *
 * On mobile the topbar shows the app icon only (via CSS); desktop shows the wordmark.
 */
export default function Brand({ to = '/', compact = false, variant = 'auto', className = '' }) {
  const forced =
    variant === 'dark' ? 'brand-forced-dark' : variant === 'light' ? 'brand-forced-light' : '';

  return (
    <Link
      className={`brand ${compact ? 'compact' : ''} ${forced} ${className}`.trim()}
      to={to}
      aria-label="Sosello home"
    >
      <img
        className="brand-icon"
        src="/web-app-manifest-192x192.png"
        alt=""
        aria-hidden="true"
        width={32}
        height={32}
      />
      <img
        className={`brand-logo logo-on-light ${compact ? 'compact' : ''}`}
        src="/logo-on-light.svg"
        alt="Sosello"
        width={compact ? 28 : 132}
        height={compact ? 28 : 41}
      />
      <img
        className={`brand-logo logo-on-dark ${compact ? 'compact' : ''}`}
        src="/logo-on-dark.svg"
        alt=""
        aria-hidden="true"
        width={compact ? 28 : 132}
        height={compact ? 28 : 41}
      />
    </Link>
  );
}
